// extracted by mini-css-extract-plugin
export var infoRow = "_up-2";
export var labelContainer = "_up-0";
export var rightInfo = "_up-1";